import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepWrapper = styled(Box)(() => ({
  paddingBottom: '2rem',
  padding: '1rem',
  marginTop: '1rem',
}));

export const TextBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  marginBottom: '1rem',
}));

export const CheckboxInput = styled('input')(() => ({
  width: '1rem',
  height: '1rem',
  border: '2px solid #adaba9',
  borderRadius: '0.25rem',
  cursor: 'pointer',
  marginTop: '0.25rem',
}));

export const CheckboxLabel = styled('label')(() => ({
  fontFamily: 'Rookery_New, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  color: '#5f5e60',
  cursor: 'pointer',
}));

export const BoxButton = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const IconWrapper = styled('img')({
  '& svg': {
    width: '2rem',
    height: '2rem',
    display: 'row',
  },
});
